import TourSection from '../ui/TourSection';
import FamilyTour from './FamilyTour';
import TextBoxImage from '../ui/TextBoxImage';
import PageWrapper from '../layout/PageWrapper';

export default function EnrollmentPage() {
  return (
    <PageWrapper key="enrollment-page">
      <TourSection key="tour-section" />
      <div className="bg-white h-8"></div>
      <FamilyTour key="family-tour" />
      <TextBoxImage key="textbox-image" />
    </PageWrapper>
  );
}
